import Layout from '@/views/layout';

const remindRouter = {
  path: '/remind',
  component: Layout,
  meta: { titlle: '跟进提醒', roles: [0, 1, 2, 3, 4] },
  redirect: { name: 'remindList' },
  children: [
    {
      path: 'remindList',
      name: 'remindList',
      component: () => import('@/views/remind/list'),
      meta: { title: '跟进提醒', roles: [0, 1, 2, 3, 4], noCache: true }
    },
    {
      path: 'remindadd',
      name: 'remindadd',
      component: () => import('@/views/remind/add'),
      meta: { title: '添加提醒', roles: [0, 1, 2, 3, 4], noCache: true }
    },
  ]
};

export default remindRouter;